<template>
  <v-dialog v-model="$store.state.search_funding_manager" persistent scrollable max-width="960">
    <v-card class="fm-filter" :class="{ 'fm-filter--dark': isDark }">
      <div class="fm-filter__header">
        <div class="d-flex align-center" style="gap: 10px">
          <span class="fm-filter__header-icon">
            <v-icon color="white" small>mdi-filter-variant</v-icon>
          </span>
          <div>
            <div class="fm-filter__title">فلترة التقارير المالية</div>
            <div class="fm-filter__subtitle">
              {{ totalCount ? `${totalCount} فلتر محدد` : "اختر الفلاتر ثم اضغط بحث" }}
            </div>
          </div>
        </div>
        <v-btn icon small @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-tabs v-model="tab" grow height="48" class="fm-filter__tabs" :slider-color="accentColor">
        <v-tab v-for="item in tabs" :key="item.key" class="fm-filter__tab">
          <v-icon small class="ml-2">{{ item.icon }}</v-icon>
          {{ item.title }}
          <span v-if="tabCounts[item.key]" class="fm-filter__count">{{ tabCounts[item.key] }}</span>
        </v-tab>
      </v-tabs>

      <v-card-text class="fm-filter__body">
        <v-tabs-items v-model="tab" class="fm-filter__tabs-items">
          <!-- تصفية الطلبات -->
          <v-tab-item>
            <section class="fm-filter__section">
              <div class="fm-filter__section-title">بيانات العميل</div>
              <v-radio-group v-model="filterType" row hide-details class="mt-0 mb-3">
                <v-radio label="إسم العميل" value="إسم العميل" :color="accentColor"></v-radio>
                <v-radio label="الملاحظة" value="الملاحظة" :color="accentColor"></v-radio>
              </v-radio-group>
              <v-row dense>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="filterTypeParts"
                    :label="'جزء من ' + filterType"
                    prepend-inner-icon="mdi-magnify"
                    v-bind="fieldProps"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="phoneNumber"
                    label="رقم الجوال"
                    prepend-inner-icon="mdi-phone-outline"
                    v-numericOnly
                    v-bind="fieldProps"
                  ></v-text-field>
                </v-col>
              </v-row>
            </section>

            <section class="fm-filter__section">
              <div class="fm-filter__section-title">فريق العمل</div>
              <v-row dense>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="selectedSalesManagers"
                    :items="salesManagers"
                    label="مدير المبيعات"
                    v-bind="multiProps"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="selectedAgents"
                    :items="agents"
                    label="استشاري المبيعات"
                    v-bind="multiProps"
                  ></v-autocomplete>
                  <v-checkbox
                    v-model="showAllAgents"
                    label="عرض كل الاستشاريين (النشطين والمؤرشفين)"
                    :color="accentColor"
                    dense
                    hide-details
                    class="mt-1 fm-filter__checkbox"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="selectedBankEmployee"
                    :items="bankEmployees"
                    label="موظف البنك"
                    no-data-text="لا يوجد موظفين بنك مسجلين"
                    v-bind="fieldProps"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </section>

            <section class="fm-filter__section">
              <div class="fm-filter__section-title">بيانات الطلب</div>
              <v-row dense>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="selectedRequestStatus"
                    :items="requestStatuses"
                    item-value="status_id"
                    label="حالة الطلب"
                    v-bind="multiProps"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="selectedRequestTypes"
                    :items="requestTypes"
                    label="نوع الطلب"
                    v-bind="multiProps"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="selectedRequestSource"
                    :items="requestSources"
                    label="مصدر المعاملة"
                    v-bind="multiProps"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="noteStatus"
                    :items="noteStatusOptions"
                    label="حالة الملاحظة"
                    v-bind="fieldProps"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-autocomplete
                    v-model="selectedWorkSources"
                    :items="workSources"
                    label="جهة العمل"
                    v-bind="multiProps"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="4">
                  <v-autocomplete
                    v-model="selectedSalarySources"
                    :items="salarySources"
                    label="جهة نزول الراتب"
                    v-bind="multiProps"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="4">
                  <v-autocomplete
                    v-model="selectedFundingSources"
                    :items="fundingSources"
                    label="جهة التمويل"
                    v-bind="multiProps"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </section>

            <section class="fm-filter__section">
              <div class="fm-filter__section-title">تاريخ الطلب</div>
              <v-row dense>
                <v-col v-for="field in requestDateFields" :key="field.key" cols="12" md="6">
                  <v-menu
                    v-model="dateMenus[field.key]"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dates[field.key]"
                        :label="field.label"
                        prepend-inner-icon="mdi-calendar-outline"
                        readonly
                        v-bind="{ ...fieldProps, ...attrs }"
                        v-on="on"
                        @click:clear="dates[field.key] = ''"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dates[field.key]"
                      :color="accentColor"
                      locale="ar"
                      no-title
                      @input="dateMenus[field.key] = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </section>
          </v-tab-item>

          <!-- التصنيفات -->
          <v-tab-item>
            <section class="fm-filter__section">
              <div class="fm-filter__section-title">التصنيفات</div>
              <v-row dense>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="classificationType"
                    :items="classificationTypeOptions"
                    label="جميع التصنيفات"
                    v-bind="fieldProps"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="selectedFundingClassifications"
                    :items="fundingClassifications"
                    label="تصنيف مشرف التمويل"
                    v-bind="multiProps"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </section>
          </v-tab-item>

          <!-- العميل -->
          <v-tab-item>
            <section class="fm-filter__section">
              <div class="fm-filter__section-title">بيانات العميل</div>
              <v-row dense>
                <v-col cols="12" md="4">
                  <v-menu
                    v-model="dateMenus.birthDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dates.birthDate"
                        label="تاريخ الميلاد"
                        prepend-inner-icon="mdi-cake-variant-outline"
                        readonly
                        v-bind="{ ...fieldProps, ...attrs }"
                        v-on="on"
                        @click:clear="dates.birthDate = ''"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dates.birthDate"
                      :color="accentColor"
                      locale="ar"
                      no-title
                      min="1940-01-01"
                      @input="dateMenus.birthDate = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="salaryFrom"
                    label="راتب العميل من"
                    prepend-inner-icon="mdi-cash"
                    v-numericOnly
                    v-bind="fieldProps"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="salaryTo"
                    label="راتب العميل إلى"
                    prepend-inner-icon="mdi-cash"
                    v-numericOnly
                    v-bind="fieldProps"
                  ></v-text-field>
                </v-col>
              </v-row>
            </section>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>

      <div class="fm-filter__footer">
        <v-btn text color="error" :disabled="!totalCount" @click="removeFilter">
          <v-icon small class="ml-1">mdi-filter-remove-outline</v-icon>
          مسح الفلاتر
        </v-btn>
        <div class="d-flex" style="gap: 8px">
          <v-btn outlined class="fm-filter__cancel" @click="close">إلغاء</v-btn>
          <v-btn depressed class="fm-filter__submit" :color="accentColor" @click="search">
            <v-icon small class="ml-1" color="white">mdi-magnify</v-icon>
            بحث
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { axiosInstance } from "@/axios/config";

const withText = (items, textKey = "value") =>
  (items || []).map((item) => ({ ...item, text: item[textKey] || item.text || item.value || item.name }));

export default {
  name: "FinanceReportFilterDialog",

  data() {
    return {
      tab: 0,
      tabs: [
        { key: "requests", title: "تصفية الطلبات", icon: "mdi-file-document-outline" },
        { key: "types", title: "التصنيفات", icon: "mdi-tag-outline" },
        { key: "client", title: "العميل", icon: "mdi-account-outline" },
      ],
      requestDateFields: [
        { key: "requestDateFrom", label: "تاريخ الطلب من" },
        { key: "requestDateTo", label: "تاريخ الطلب إلى" },
      ],

      filterType: "إسم العميل",
      filterTypeParts: "",
      phoneNumber: "",
      salesManagers: [],
      selectedSalesManagers: [],
      agents: [],
      selectedAgents: [],
      showAllAgents: false,
      bankEmployees: [],
      selectedBankEmployee: null,
      noteStatusOptions: ["بها محتوي", "فارغه"],
      noteStatus: null,
      requestStatuses: [],
      selectedRequestStatus: [],
      requestSources: [],
      selectedRequestSource: [],
      requestTypes: ["شراء", "رهن", "تساهيل", "شراء-دفعة", "رهن-شراء"],
      selectedRequestTypes: [],
      workSources: [],
      selectedWorkSources: [],
      salarySources: [],
      selectedSalarySources: [],
      fundingSources: [],
      selectedFundingSources: [],

      classificationTypeOptions: ["ايجابي", "سلبي", "إدارة"],
      classificationType: null,
      fundingClassifications: [],
      selectedFundingClassifications: [],

      salaryFrom: "",
      salaryTo: "",
      dates: { requestDateFrom: "", requestDateTo: "", birthDate: "" },
      dateMenus: { requestDateFrom: false, requestDateTo: false, birthDate: false },
    };
  },

  computed: {
    isDark() {
      return !!this.$store.getters.isDark;
    },

    accentColor() {
      return this.isDark ? "#8b7bd8" : "#3F0E40";
    },

    fieldProps() {
      return {
        outlined: true,
        dense: true,
        clearable: true,
        hideDetails: true,
        menuProps: { offsetY: true },
      };
    },

    multiProps() {
      return {
        ...this.fieldProps,
        multiple: true,
        smallChips: true,
        deletableChips: true,
        itemValue: "id",
        itemText: "text",
        noDataText: "لا توجد بيانات",
      };
    },

    tabCounts() {
      const filled = (val) => (Array.isArray(val) ? val.length > 0 : !!val);
      const count = (values) => values.filter(filled).length;
      return {
        requests: count([
          this.filterTypeParts,
          this.phoneNumber,
          this.selectedSalesManagers,
          this.selectedAgents,
          this.selectedBankEmployee,
          this.noteStatus,
          this.selectedRequestStatus,
          this.selectedRequestSource,
          this.selectedRequestTypes,
          this.selectedWorkSources,
          this.selectedSalarySources,
          this.selectedFundingSources,
          this.dates.requestDateFrom,
          this.dates.requestDateTo,
        ]),
        types: count([this.classificationType, this.selectedFundingClassifications]),
        client: count([this.dates.birthDate, this.salaryFrom, this.salaryTo]),
      };
    },

    totalCount() {
      return Object.values(this.tabCounts).reduce((sum, value) => sum + value, 0);
    },
  },

  watch: {
    showAllAgents() {
      this.getAgents();
    },
    selectedSalesManagers() {
      this.getAgents();
    },
  },

  methods: {
    close() {
      this.$store.state.search_funding_manager = false;
    },

    getAgents() {
      const body = new FormData();
      body.append("role", "agent");
      body.append("status", this.showAllAgents ? 2 : 1);
      this.selectedSalesManagers.forEach((id, index) => {
        body.append(`manager_id[${index}]`, id);
      });
      axiosInstance
        .post(`/employee/admin/filterUsers?funding_manager_id=${localStorage["id"]}`, body)
        .then((res) => {
          this.agents = withText(res.data.payload, "name");
          const available = this.agents.map((agent) => agent.id);
          this.selectedAgents = this.selectedAgents.filter((id) => available.includes(id));
        });
    },

    getSalesManagers() {
      axiosInstance.post("/employee/admin/filterUsers", { role: "manager" }).then((res) => {
        this.salesManagers = withText(res.data.payload, "name");
      });
    },

    getBankEmployees() {
      axiosInstance.get("/employee/funding-manager/get-bank-employees").then((res) => {
        this.bankEmployees = res.data.payload;
      });
    },

    getLookups() {
      axiosInstance.get("/agent/RequestStatus").then((res) => {
        this.requestStatuses = withText(res.data.payload);
      });
      axiosInstance.get("/agent/Request/Sources").then((res) => {
        this.requestSources = withText(res.data.payload);
      });
      axiosInstance.get("/customer/WorkSources").then((res) => {
        this.workSources = withText(res.data.payload);
      });
      axiosInstance.get("/customer/SalarySources").then((res) => {
        this.salarySources = withText(res.data.payload);
      });
      axiosInstance.get("/agent/Funding/Sources").then((res) => {
        this.fundingSources = withText(res.data.payload);
      });
      axiosInstance.get("/agent/Request/Classification?type_of_classification=2").then((res) => {
        this.fundingClassifications = withText(res.data.payload);
      });
    },

    removeFilter() {
      this.filterTypeParts = "";
      this.phoneNumber = "";
      this.selectedSalesManagers = [];
      this.selectedAgents = [];
      this.selectedBankEmployee = null;
      this.noteStatus = null;
      this.selectedRequestStatus = [];
      this.selectedRequestSource = [];
      this.selectedRequestTypes = [];
      this.selectedWorkSources = [];
      this.selectedSalarySources = [];
      this.selectedFundingSources = [];
      this.classificationType = null;
      this.selectedFundingClassifications = [];
      this.salaryFrom = "";
      this.salaryTo = "";
      this.dates = { requestDateFrom: "", requestDateTo: "", birthDate: "" };
      this.$store.state.admin_search_active = false;
    },

    search() {
      const body = new FormData();
      const appendList = (key, list) => {
        list.forEach((value, index) => body.append(`${key}[${index}]`, value));
      };

      if (this.filterTypeParts) body.append("text_name", this.filterTypeParts);
      if (this.phoneNumber) body.append("customer_phone", this.phoneNumber);
      appendList("sales_manager_ids", this.selectedSalesManagers);
      appendList("agent_name", this.selectedAgents);
      if (this.selectedBankEmployee) body.append("funding_manager_employee_bank", this.selectedBankEmployee);
      if (this.noteStatus) body.append("note_status", this.noteStatus === "بها محتوي" ? 1 : 0);
      appendList("request_status", this.selectedRequestStatus);
      appendList("request_source", this.selectedRequestSource);
      appendList("request_types", this.selectedRequestTypes);
      appendList("work_source", this.selectedWorkSources);
      appendList("salary_source", this.selectedSalarySources);
      appendList("funding_source", this.selectedFundingSources);
      if (this.dates.requestDateFrom) body.append("request_date_from", this.dates.requestDateFrom);
      if (this.dates.requestDateTo) body.append("request_date_to", this.dates.requestDateTo);

      const classificationValues = { سلبي: 0, ايجابي: 1, إدارة: 2 };
      if (this.classificationType) {
        body.append("agent_positive_or_negative_classification", classificationValues[this.classificationType]);
      }
      appendList("funding_manager_classification", this.selectedFundingClassifications);

      if (this.dates.birthDate) body.append("customer_birth_date", this.dates.birthDate);
      if (this.salaryFrom) body.append("customer_salary_from", this.salaryFrom);
      if (this.salaryTo) body.append("customer_salary_to", this.salaryTo);

      this.$store.state.isSearch = true;
      this.$store.state.bodySearch = body;
      this.close();
      this.$emit("fireSearch", 1);
    },
  },

  mounted() {
    this.getAgents();
    this.getSalesManagers();
    this.getBankEmployees();
    this.getLookups();
  },
};
</script>

<style>
.v-dialog .fm-filter.v-card {
  --fm-bg: #ffffff;
  --fm-surface: #f7f7fa;
  --fm-border: #e4e4ec;
  --fm-text: #1f1d2b;
  --fm-muted: #6b6880;
  --fm-field: #ffffff;
  --fm-accent: #3f0e40;
  border-radius: 12px !important;
  overflow: hidden;
  background: var(--fm-bg) !important;
  color: var(--fm-text) !important;
}

.v-dialog .fm-filter.fm-filter--dark {
  --fm-bg: #1e2129;
  --fm-surface: #262a34;
  --fm-border: #353a47;
  --fm-text: #eceaf4;
  --fm-muted: #a3a1b3;
  --fm-field: #1e2129;
  --fm-accent: #8b7bd8;
}

.fm-filter__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid var(--fm-border);
}

.fm-filter__header-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: var(--fm-accent);
}

.fm-filter__title {
  font-size: 16px;
  font-weight: 700;
  color: var(--fm-text);
}

.fm-filter__subtitle {
  font-size: 12px;
  color: var(--fm-muted);
}

.v-dialog .fm-filter .fm-filter__tabs > .v-tabs-bar {
  background: var(--fm-bg) !important;
  border-bottom: 1px solid var(--fm-border);
}

.v-dialog .fm-filter .fm-filter__tab {
  font-weight: 600;
  letter-spacing: 0;
  color: var(--fm-muted) !important;
}

.v-dialog .fm-filter .fm-filter__tab .v-icon {
  color: inherit !important;
}

.v-dialog .fm-filter .fm-filter__tab.v-tab--active {
  color: var(--fm-accent) !important;
}

.fm-filter__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  margin-right: 8px;
  border-radius: 10px;
  font-size: 11px;
  color: #fff;
  background: var(--fm-accent);
}

.v-dialog .fm-filter .fm-filter__body {
  padding: 16px 20px !important;
  max-height: 62vh;
  background: var(--fm-bg) !important;
}

.v-dialog .fm-filter .fm-filter__tabs-items,
.v-dialog .fm-filter .fm-filter__tabs-items .v-window-item {
  background: transparent !important;
}

.fm-filter__section {
  padding: 14px 16px 16px;
  margin-bottom: 14px;
  border: 1px solid var(--fm-border);
  border-radius: 10px;
  background: var(--fm-surface);
}

.fm-filter__section:last-child {
  margin-bottom: 0;
}

.fm-filter__section-title {
  margin-bottom: 12px;
  font-size: 13px;
  font-weight: 700;
  color: var(--fm-text);
}

.v-dialog .fm-filter .v-input,
.v-dialog .fm-filter .v-input__control {
  background: transparent !important;
  color: var(--fm-text) !important;
}

.v-dialog .fm-filter .v-text-field--outlined > .v-input__control > .v-input__slot {
  background: var(--fm-field) !important;
  min-height: 42px !important;
}

.v-dialog .fm-filter .v-text-field--outlined fieldset {
  border-color: var(--fm-border) !important;
}

.v-dialog .fm-filter .v-text-field--outlined.v-input--is-focused fieldset {
  border-color: var(--fm-accent) !important;
  border-width: 2px;
}

.v-dialog .fm-filter .v-text-field__slot input,
.v-dialog .fm-filter .v-select__selections input {
  background: transparent !important;
  color: var(--fm-text) !important;
  padding: 8px 0 !important;
}

.v-dialog .fm-filter .v-select__selection,
.v-dialog .fm-filter .v-label,
.v-dialog .fm-filter .v-radio .v-label,
.v-dialog .fm-filter .v-input--checkbox .v-label {
  color: var(--fm-muted) !important;
}

.v-dialog .fm-filter .v-label--active {
  background: var(--fm-field);
  padding: 0 4px;
}

.v-dialog .fm-filter .v-input--is-focused .v-label--active {
  color: var(--fm-accent) !important;
}

.v-dialog .fm-filter .v-input__icon .v-icon,
.v-dialog .fm-filter .v-input--selection-controls__input .v-icon {
  color: var(--fm-muted) !important;
}

.v-dialog .fm-filter .v-chip {
  background: var(--fm-accent) !important;
  color: #fff !important;
}

.v-dialog .fm-filter .v-chip .v-icon {
  color: #fff !important;
}

.fm-filter__checkbox .v-label {
  font-size: 13px;
}

.fm-filter__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-top: 1px solid var(--fm-border);
  background: var(--fm-bg);
}

.v-dialog .fm-filter .fm-filter__cancel {
  color: var(--fm-text) !important;
  border-color: var(--fm-border) !important;
}

.v-dialog .fm-filter .fm-filter__submit {
  min-width: 110px !important;
  color: #fff !important;
}
</style>
